module.exports = __webpack_public_path__ + "static/media/credit-card.e3888a82.svg";